import {HttpAxiosRequest} from "src/http/httpAxiosBase";
import {UserPosition} from "src/types/user/userCacheData";

export const HttpCacheUser = {
    getEndpoint: (url: string) => `cache/usuario${url}`,

    getPositionList: (): Promise<UserPosition[]> => {
        return HttpAxiosRequest.get(
            HttpCacheUser.getEndpoint("/cargos")
        );
    },
}